import { EntityState } from "@ngrx/entity";

import { FollowEntity } from '../entities';

export interface FollowState extends EntityState<FollowEntity> {
    isLoading: boolean,
    isLoaded: boolean
}